// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBQoz2RdEqpfIJtvg3KpPbmQ7b_UwXpgH0",
  authDomain: "learn-languages-main-397.firebaseapp.com",
  projectId: "learn-languages-main-397",
  storageBucket: "learn-languages-main-397.firebasestorage.app",
  messagingSenderId: "755023766574",
  appId: "1:755023766574:web:bc8746d3a50d8c27f3ebbf",
  measurementId: "G-JPYTH07HGJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app;
// Note: The above code initializes Firebase and exports the app instance.
// You can now use this app instance to access Firebase services like Firestore, Auth, etc.
// If you need to use other Firebase services, you can import them like this:
// import { getFirestore } from "firebase/firestore";
// const db = getFirestore(app);
// Make sure to install the Firebase SDK if you haven't already:
// npm install firebase
// You can also export other Firebase services if needed
// export { app, analytics };
//